<template>
  <i class="mr-1" :class="[estilo, loading ? 'fa-spinner fa-spin' : icono]"></i>
</template>

<script>
export default {
  name: "i-submit",
  props: {
    estilo: {
      type: String,
      default: "fa-solid",
    },
    icono: String,
    loading: Boolean,
  },
};
</script>